<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2 *ngIf="isEditable">
                {{'grouping.list.title.shortLabel' | translate}}
                <app-tooltip text="{{'grouping.list.title.summary' | translate}}"></app-tooltip>
            </h2>
            <h2 *ngIf="!isEditable">
                {{'grouping.list.templateGroups.shortLabel' | translate}}
                <app-tooltip text="{{'grouping.list.templateGroups.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <button mat-mini-fab color="accent"
            *ngIf="isEditable"
            (click)="onAddGroup()"
            [matTooltip]="'grouping.list.create.summary' | translate">
            <mat-icon aria-label="Add">add</mat-icon>
        </button>
        <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="accent"></mat-progress-bar>
        <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'grouping.list.name.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let group"> {{ group.text.shortLabel }} </td>
            </ng-container>

            <ng-container matColumnDef="region">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'grouping.list.region.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let group"> {{ group.region.text.shortLabel }} </td>
            </ng-container>

            <ng-container matColumnDef="length">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'grouping.list.townsLength.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let group"> {{ group.organisms ? group.organisms.length : 0 }} </td>
            </ng-container>

            <ng-container matColumnDef="createdBy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'grouping.list.createdBy.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let group"> {{ group.createdBy || systemName }} </td>
            </ng-container>

            <ng-container matColumnDef="isPublic">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'grouping.list.isPublic.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let group">
                    <mat-icon aria-label="Checked" [ngClass]="{checked: group.isPublic}">
                        {{ group.isPublic ? 'check_box' : 'check_box_outline_blank' }}
                    </mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> {{ 'users.licencesList.actions.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let group">
                    <button mat-icon-button class="action-button" color="accent"
                        *ngIf="group.createdBy === userName" [disabled]="isLoading"
                        [matTooltip]="'grouping.list.edit.summary' | translate" (click)="onSelect(group)">
                        <mat-icon aria-label="Edit">edit</mat-icon>
                    </button>
                    <button mat-icon-button class="action-button" color="accent"
                        *ngIf="group.createdBy === userName" [disabled]="isLoading"
                        [matTooltip]="'grouping.list.delete.summary' | translate" (click)="onDeleteGroup(group)">
                        <mat-icon aria-label="Edit">delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <p *ngIf="!groups.length">{{ 'grouping.list.empty.summary' | translate }}</p>
    </mat-card-content>
</mat-card>
